// extracted by mini-css-extract-plugin
export default {"card":"FullWidthCard_card__bDPLn"};